import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store/reducers/ui";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function InfoSnackbar() {
  const dispatch = useDispatch();

  const infoMessage = useSelector((state) => state.ui.infoMessage);

  const handleClose = () => {
    dispatch(uiActions.infoMessage({ ...infoMessage, open: false }));
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={infoMessage.open}
      onClose={handleClose}
      key={infoMessage.id}
      autoHideDuration={7000}
    >
      <Alert
        onClose={handleClose}
        severity={infoMessage.type}
        sx={{ width: "100%", color: infoMessage.type === "info" && "black" }}
      >
        {infoMessage.message}
      </Alert>
    </Snackbar>
  );
}
